import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { getStatusIconClassName, getStatusTextClassName } from '../models/TransactionStatus';

@Component({
    selector: 're-transaction-log-detail-more',
    templateUrl: './transaction-log-detail-more.component.html',
    styleUrls: ['./transaction-log-detail-more.component.scss'],
    standalone: false
})
export class TransactionLogDetailMoreComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }
  productName: string;
  status: string="";
  statusDescription: string;

  close() {
    this.activeModal.close(true);
  }

  getStatusIconClassName(status: string) {
    return getStatusIconClassName(status);
  }

  getStatusTextClassName(status: string) {
    return getStatusTextClassName(status);
  }

}
